module.exports = __webpack_public_path__ + "img/scrying-mirror-2.5f30fcae.webp";